import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'numberToWords',
  standalone: true
})
export class NumberToWordsPipe implements PipeTransform {
  // transform(value: number | string): string {
  //   if (!value) return ''

  //   const num = Number(value)

  //   if (isNaN(num)) return ''

  //   return this.convertToWords(num) + ' Rupees Only'
  // }

  transform(value: number | string): string {
    if (value === null || value === undefined || value === '') {
      return ''
    }

    const num = Number(value)

    if (isNaN(num)) {
      return ''
    }

    const rupees = Math.floor(num)
    const paise = Math.round((num - rupees) * 100)

    let result = `${this.convertToWords(rupees)} Rupees`

    if (paise > 0) {
      result += ` and ${this.convertToWords(paise)} Paise`
    }

    return result + ' Only'
  }

  private convertToWords(num: number): string {
    const ones = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen'
    ]

    const tens = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety'
    ]

    if (num < 20) {
      return ones[num]
    }

    if (num < 100) {
      return tens[Math.floor(num / 10)] + ' ' + ones[num % 10]
    }

    if (num < 1000) {
      return ones[Math.floor(num / 100)] + ' Hundred ' + this.convertToWords(num % 100)
    }

    if (num < 100000) {
      return (
        this.convertToWords(Math.floor(num / 1000)) + ' Thousand ' + this.convertToWords(num % 1000)
      )
    }

    if (num < 10000000) {
      return (
        this.convertToWords(Math.floor(num / 100000)) + ' Lakh ' + this.convertToWords(num % 100000)
      )
    }

    return (
      this.convertToWords(Math.floor(num / 10000000)) +
      ' Crore ' +
      this.convertToWords(num % 10000000)
    )
  }
}
